//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueApexCharts from 'vue-apexcharts';


export default {
	name: 'GenderChart',
	components: {
		apexchart: VueApexCharts,
	},
	props: {
		seriesData: {
			type: Object,
			required: true,
		},

	},
	data: () => ({
		chartOptions: {
			chart: {
				toolbar: {
					show: false,
				},
				type: 'bar',
				height: 440,
				stacked: true,
				parentHeightOffset: 15,
			},

			colors: ['#1635FB', '#008FFB'],
			plotOptions: {
				bar: {
					horizontal: true,
					barHeight: '80%',
				},
			},
			dataLabels: {
				enabled: false,
			},
			stroke: {
				width: 1,
				colors: ['#fff'],
			},

			grid: {
				xaxis: {
					lines: {
						show: false,
					},
				},
			},
			yaxis: {
				min: -100,
				max: 100,
			},
			tooltip: {
				shared: false,
				x: {
					formatter: function(val) {
						return val;
					},
				},
				y: {
					formatter: function(val) {
						return `${Math.abs(val)}%`;
					},
				},
			},
			xaxis: {
				categories: ['65+', '55-64', '45-54', '35-44', '25-34', '18-24', '13-17'],
				labels: {
					formatter: function(val) {
						return `${Math.abs(Math.round(val))}%`;
					},
				},
			},
		},
	}),

	computed: {
		total() {
			return this.seriesData.femaleTotal + this.seriesData.maleTotal;
		},
		femalePerc() {
			return Math.round((this.seriesData.femaleTotal / this.total) * 100) || 0;
		},
		malePerc() {
			return Math.round((this.seriesData.maleTotal / this.total) * 100) || 0;
		},
		series() {
			if (!this.seriesData.male) {
				return [];
			}
			return [
				{
					name: 'Männer',
					data: this.seriesData.male.map(el => el.y * -1),
				},
				{
					name: 'Frauen',
					data: this.seriesData.female.map(el => el.y),
				},
			];
		},
	},

};
